import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { scale, verticalScale } from "../../utils/scale";

export class AddressComponent extends React.Component {
  render() {
    return (
      <View style={[styles.mainContainer, this.props.containerStyle]}>
        <View style={{ flexDirection: "row", justifyContent: "center" }}>
          <Text style={styles.titleText}>{this.props.title}</Text>
        </View>
        <View style={styles.divider} />
        <View
          style={[
            styles.textInputContainer,
            this.props.textInputContainerStyle,
          ]}
        >
          <Text {...this.props} style={styles.valuetext}>
            {this.props.value}
          </Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  mainContainer: { width: "100%", marginTop: verticalScale(20) },
  titleStyle: {
    fontSize: scale(14),
    width: scale(330),
    alignSelf: "center",
    height: verticalScale(20),
    lineHeight: 18,
    marginLeft: scale(5),
  },
  textInputContainer: {
    width: scale(330),
    borderRadius: scale(4),
    height: verticalScale(50),
    marginVertical: verticalScale(5),
    alignSelf: "center",
    justifyContent: "center",
  },
  textStyle: {
    marginLeft: scale(15),
    fontFamily: "Muli",
    width: "90%",
    color: "black",
  },
  titleText: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 12,
    marginTop: 10,
    color: "rgba(0,0,0,0.56)",
  },
  divider: {
    backgroundColor: "rgba(0,0,0,.1)",
    height: 1,
    marginTop: verticalScale(10),
    width: "100%",
    alignSelf: "center",
  },
  valuetext: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 12,
    marginLeft: scale(15),
    width: "90%",
  },
});
